import { type ApplicationConfiguration, touchpoint } from "@qs/app-shell";

export const createApplicationConfiguration = (
    publicServerUrl: string,
    providerId: string = process.env.CPQ_PROVIDER_ID || "immosoerf"
): ApplicationConfiguration => {
    return {
        name: "cpq-cds-demo-app",
        microFrontends: [
            {
                name: "cpq-cds",
                originUrl: `${publicServerUrl}/mfe.js`,
                useTouchpoints: [
                    touchpoint("order-request", { properties: { providerId } }),
                    touchpoint("service-definition-catalog", { properties: { providerId } }),
                    touchpoint("manage-service-definitions", { properties: { providerId } }),
                    touchpoint("provider-orders-overview", { properties: { providerId } }),
                ],
            },
        ],
    };
};
